import React from 'react';
import { weekString } from '../../Services/helpers';
import { usePreference } from '../../Data/Preference';
import { Navigate } from 'react-router-dom';

const WeekRedirect = () => {
    const [selectedWeek] = usePreference('calendar:selectedWeek', weekString(), true);

    return <Navigate to={'/plan/calendar/'+selectedWeek} />
}

export default WeekRedirect;
